export function fabricators() {
    $(".fabricators-main").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<div class='fabricl-btn prev'><svg viewBox='0 0 52 13' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='m10.178 12.38-10-5.773 10-5.774v4.774h40a1 1 0 1 1 0 2h-40v4.773Z'/></svg></div>",
        nextArrow: "<div class='fabricl-btn next'><svg viewBox='0 0 52 13' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='m41.292.833 10 5.774-10 5.773V7.607h-40a1 1 0 1 1 0-2h40V.833Z'/></svg></div>",
        fade: true,
        asNavFor: ".fabricators-nav",
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: false
                }
            }
        ]
    });
    $(".fabricators-nav").slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: ".fabricators-main",
        focusOnSelect: true
    });


}


// WEBPACK FOOTER //
// ./assets/js/modules/fabricators.js